/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext } from 'react'

type ContextState = {
  isTicketModalOpen: boolean
  setIsTicketModalOpen: (newstate: boolean) => void
  ticketToEdit: number
  setTicketToEdit: (newstate: number) => void
}

const initialState = {
  isTicketModalOpen: false,
  setIsTicketModalOpen: () => {},
  ticketToEdit: 0,
  setTicketToEdit: () => {},
}

export const HandleTicketModalContext = React.createContext<ContextState>(initialState)

export function HandleTicketModalProvider({ children }: { children: React.ReactNode }) {
  const [isTicketModalOpen, setIsTicketModalOpen] = useState<boolean>(
    initialState.isTicketModalOpen,
  )
  const [ticketToEdit, setTicketToEdit] = useState<number>(initialState.ticketToEdit)

  return (
    <HandleTicketModalContext.Provider
      value={{ isTicketModalOpen, ticketToEdit, setIsTicketModalOpen, setTicketToEdit }}
    >
      {children}
    </HandleTicketModalContext.Provider>
  )
}

export function useHandleTicketModal(): ContextState {
  const context = useContext(HandleTicketModalContext)
  if (!context)
    throw Error('This hook can only be used under the HandleTicketModalContextProvider component')
  return context
}
